<script>
  import Icon from "$lib/components/Icon.svelte";
  import Card from "../Card.svelte";
  import { formatDate } from "$lib/utilities/date";
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  import { page } from "$app/stores";

  export let url = "";
  export let title;
  export let description = "";
  export let timestamp = "";
  $: isExternal = isExternalUrl(url, $page.url?.origin);
</script>

<Card
  {url}
  class="flex flex-row items-center w-full lg:w-806 px-24 py-16 md:py-24 hover:underline focus:underline focus-within:underline mx-auto"
>
  <!-- body -->
  <div class="w-full flex flex-col gap-16 items-start">
    <!-- title -->
    <a
      href={url}
      class="text-black no-underline focus:!bg-none focus:!outline-none heading-card font-normal active:text-black w-full"
      data-sveltekit-reload
      target={isExternal ? "_blank" : null}
      rel={isExternal ? "noopener noreferrer" : null}
      on:click={(e) => {
        e.stopPropagation();
      }}
    >
      <div class="flex flex-row justify-between items-start">
        {title}
        <div class="lg:text-size-16 md:text-size-14 px-16">
          {#if isExternal}
            <Icon type="external" size="md" class="!inline ml-8 align-top" />
          {/if}
        </div>
      </div>
    </a>

    <!-- description -->
    <p class="font-normal line-clamp-9 md:line-clamp-6 lg:line-clamp-3">{description}</p>

    <!-- timestamp -->
    <p class="font-normal">{formatDate(timestamp)}</p>
  </div>
</Card>
